import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Ruta_Sesion } from 'generated/graphql';

const initialState: Ruta_Sesion[] = null as any;

const evaluacionesStateSlice = createSlice({
	name: 'evaluacionesState',
	initialState,
	reducers: {
		setEvaluacionesState: (state, action: PayloadAction<Ruta_Sesion[]>) => {
			return action.payload;
		},
		resetEvaluacionState: () => {
			return initialState;
		}
	}
});

export const { setEvaluacionesState, resetEvaluacionState } = evaluacionesStateSlice.actions;

export default evaluacionesStateSlice.reducer;
